import type { ReactNode } from 'react'

interface HomeSecondaryRowProps {
  children: ReactNode
}

export function HomeSecondaryRow({ children }: HomeSecondaryRowProps) {
  return <div className="home-secondary-row">{children}</div>
}
